import { useEffect, useState } from "react";

const useBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetch("https://mbababd24.onrender.com/booking")
      .then((res) => res.json())
      .then((data) => setBookings(data.reverse()));
    setIsLoading(false);
  }, []);
  return [bookings, isLoading];
};

export default useBookings;
